import React from 'react';
import PropTypes from 'prop-types';

import './style.scss';
// import { IconHamburger, IconLeftArrow, IconRefresh } from 'svgIcons/MotionPortalIcons';
// import IconHierarchyView from 'svgIcons/MotionPortalIcons/IconHierarchyView';
import { conditionIndicesViewOptions, toggleButtonOptions } from '../../../PowertrainConditionMonitoring/ConditionIndicesOverviewV2/constants';
// import { GeneralButton } from 'sharedComponents/GeneralButton';
// import { translate } from 'helpers/translateHelper';
// import colors from 'theme/_colors.scss';
import LastUpdated from './LastUpdated';
import ConditionOverviewToggle from './ConditionOverviewToggle';
import CollapseButton from './CollapseButton';
/**
 * Headless, highly optimized Sidebar component.
 * - Title at top left (vertical when collapsed)
 * - Toggle icon at bottom right (changes based on expanded/collapsed state)
 * - Children rendered in the center (only when expanded)
 * - Controlled by `expanded` prop, toggle via `onToggle`
 */
const SideBar = ({
    title,
    expanded,
    onToggle,
    expandedIcon,
    collapsedIcon,
    children,
    className = '',
    style = {},
    isRight,
    showCollapseButton,
    isForConditionOverview,
    conditionIndicesView,
    setConditionIndicesView,
    requestHierarchyData,
    lastUpdatedTimestamp,
    assetsLastUpdatedTimestamp,
    activeTab,
    contentPadding
}) => {
    const isActiveList = conditionIndicesView === conditionIndicesViewOptions.LIST;
    const showHierarchyTimestamp = conditionIndicesView === conditionIndicesViewOptions.HIERARCHY ||
        conditionIndicesView === conditionIndicesViewOptions.LIST && activeTab === toggleButtonOptions.ASSETS;

    return (
        <aside
            className={`column-sidebar-root ${expanded ? 'sidebar-expanded' : 'sidebar-collapsed'} ${className ? '' + className : ''}`}
            style={{ ...style }}
            aria-expanded={expanded}
        >
            {/* Top Title */}
            <div className={`column-sidebar-title ${expanded ? 'expanded' : 'collapsed'}`}>
                {title}
                {isForConditionOverview && expanded && showHierarchyTimestamp &&
                    <LastUpdated
                        isActiveList={isActiveList}
                        assetsLastUpdatedTimestamp={assetsLastUpdatedTimestamp}
                        lastUpdatedTimestamp={lastUpdatedTimestamp}
                        requestHierarchyData={requestHierarchyData}
                    />
                }
            </div>

            {/* Center Content */}
            {expanded &&
                <div
                    style={{
                        flex: 1,
                        overflow: 'auto',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        padding: contentPadding,
                    }}
                >
                    {children}
                </div>
            }

            {isForConditionOverview &&
                <ConditionOverviewToggle
                    expanded={expanded}
                    conditionIndicesView={conditionIndicesView}
                    setConditionIndicesView={setConditionIndicesView}
                    isRight={isRight}
                    showCollapseButton={showCollapseButton}
                    onToggle={onToggle}
                    expandedIcon={expandedIcon}
                    collapsedIcon={collapsedIcon}
                />
            }

            {/* Bottom Right Toggle Icon */}
            {showCollapseButton && !isForConditionOverview &&
                <CollapseButton
                    expanded={expanded}
                    onToggle={onToggle}
                    isRight={isRight}
                    expandedIcon={expandedIcon}
                    collapsedIcon={collapsedIcon}
                />
            }
        </aside>
    );
};

SideBar.propTypes = {
    title: PropTypes.node,
    expanded: PropTypes.bool.isRequired,
    onToggle: PropTypes.func.isRequired,
    expandedIcon: PropTypes.node,
    collapsedIcon: PropTypes.node,
    children: PropTypes.node,
    className: PropTypes.string,
    style: PropTypes.object,
    isRight: PropTypes.bool, // Optional prop to indicate if it's a right sidebar
    showCollapseButton: PropTypes.oneOfType([PropTypes.bool, PropTypes.node]), // Optional prop to control visibility of toggle button
    isForConditionOverview: PropTypes.bool,
    conditionIndicesView: PropTypes.oneOf(Object.values(conditionIndicesViewOptions)),
    setConditionIndicesView: PropTypes.func,
    requestHierarchyData: PropTypes.func,
    lastUpdatedTimestamp: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.instanceOf(Date)]),
    assetsLastUpdatedTimestamp: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.instanceOf(Date)]),
    activeTab: PropTypes.oneOf(Object.values(toggleButtonOptions)),
    contentPadding: PropTypes.string,
};

SideBar.defaultProps = {
    title: '',
    expandedIcon: <span>&#x25C0;</span>,   // ◀
    collapsedIcon: <span>&#x25B6;</span>, // ▶
    children: null,
    className: '',
    style: {},
    isRight: false, // Default to false for left sidebar
    showCollapseButton: true,
    isForConditionOverview: false,
    conditionIndicesView: conditionIndicesViewOptions.LIST,
    setConditionIndicesView: () => { },
    requestHierarchyData: null,
    lastUpdatedTimestamp: null,
    assetsLastUpdatedTimestamp: null,
    contentPadding: '0 16px',
    activeTab: toggleButtonOptions.ASSETS,
};

export default React.memo(SideBar);
